module.exports = __webpack_public_path__ + "static/media/headerLogo.5dc4d71e.png";